/*
 * Public API Surface of inova-core
 */


export * from './inova-core-button.component';

